hostlessProtocol